import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const TwitterIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M5 .91a4.344 4.344 0 1 0 0 8.686A4.344 4.344 0 0 0 5 .91Zm2.419 6.453c0 .193-.16.35-.358.35H2.93a.354.354 0 0 1-.36-.35V3.184c0-.193.161-.35.36-.35h4.13c.197 0 .358.157.358.35v4.179Z" />
            <path d="M5 1c2.208 0 4 1.792 4 4S7.208 9 5 9 1 7.208 1 5s1.792-4 4-4Zm-.705 6.127c1.77 0 2.738-1.466 2.738-2.737 0-.042 0-.084-.002-.124.188-.136.352-.305.481-.499a1.953 1.953 0 0 1-.553.152c.2-.12.352-.308.424-.533a1.95 1.95 0 0 1-.611.233.962.962 0 0 0-1.638.878A2.73 2.73 0 0 1 3.15 3.492a.965.965 0 0 0 .3 1.283.945.945 0 0 1-.436-.12v.012c0 .467.332.854.773.944a.96.96 0 0 1-.435.016.96.96 0 0 0 .898.668 1.934 1.934 0 0 1-1.425.397 2.68 2.68 0 0 0 1.47.435Z" />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const TwitterIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M5 .91a4.344 4.344 0 1 0 0 8.686A4.344 4.344 0 0 0 5 .91Zm2.419 6.453c0 .193-.16.35-.358.35H2.93a.354.354 0 0 1-.36-.35V3.184c0-.193.161-.35.36-.35h4.13c.197 0 .358.157.358.35v4.179Z" />
            <path d="M5 1c2.208 0 4 1.792 4 4S7.208 9 5 9 1 7.208 1 5s1.792-4 4-4Zm-.705 6.127c1.77 0 2.738-1.466 2.738-2.737 0-.042 0-.084-.002-.124.188-.136.352-.305.481-.499a1.953 1.953 0 0 1-.553.152c.2-.12.352-.308.424-.533a1.95 1.95 0 0 1-.611.233.962.962 0 0 0-1.638.878A2.73 2.73 0 0 1 3.15 3.492a.965.965 0 0 0 .3 1.283.945.945 0 0 1-.436-.12v.012c0 .467.332.854.773.944a.96.96 0 0 1-.435.016.96.96 0 0 0 .898.668 1.934 1.934 0 0 1-1.425.397 2.68 2.68 0 0 0 1.47.435Z" />
        </SvgIcon>
    );
};
